    <ng-container *ngIf="productType.NCP_SUB_TYPE === product.product_type">
        <div class="ncp-card-{{cardType}} position-relative ncp-card-container w-100"
            [ngClass]="{'mt-3': cardType === cardTypeConst.SINGLE}"
            [ngStyle]="{'background-color': templateColor.card, 'outline': '1px solid '+ templateColor.outline}">
            <div  class="position-absolute w-100 h-100 masking-div" 
                *ngIf="channel?.content_visibility?.display==0 || channel?.content_visibility?.display==2">
                 <app-product-masking-card 
                    [content_visibility]="channel?.content_visibility">
                </app-product-masking-card>
            </div>
            <div class="d-flex align-items-start">
                <div class="d-inline-flex flex-column w-50">
                    <span class="heading-4 ellipsis mb-2"
                        [ngStyle]="{'color': templateColor.title}">
                        {{product.title}}
                    </span>
                    <span class="secondary-paragraph ellipsis"
                        [ngStyle]="{'color': templateColor.sponser_category}">
                        {{mls.languageText.ncp_card_screen.key8}}&nbsp;{{sponser.name}}
                    </span>
                </div>
                <div class="d-inline-flex align-items-end flex-column w-50 secondary-paragraph"
                  [ngStyle]="{'color': templateColor.sponser_category}">
                  <span class="ellipsis mb-1 w-100 text-right" [title]="product.category_name">
                    {{product.category_name}}
                  </span>
                  <span class="ellipsis w-100 text-right" [title]="specialtyTitle">
                    {{specialtyName}}
                  </span>
                </div>
            </div>
            <div class="ncp-banner {{imgHeight}} mt-3">
                <img [src]="image.banner" onerror="this.src='assets/images/game/game_placeholder.jpg'"
                    alt="game banner"
                    (click)="navigateToGameDetail(true)"
                    [appAnalyticsEvent]="analyticsGameData"
                    class="cursor-pointer"/>
            </div>
            <div class="btn-design large filled cursor-pointer mt-3 bm-16"
                (click)="navigateToGameScreen()"
                [appAnalyticsEvent]="analyticsPlayNowData"
                [ngStyle]="{'background-image': 'linear-gradient(to bottom,' + templateColor.card_cta + ' 0%, '+ templateColor.card_cta_another + ' 97%)' }">
                <span class="ellipsis"
                    [title]="templateText.product_button_text"
                    [ngStyle]="{'color': templateColor.card_cta_text}" >
                    {{templateText.product_button_text}}
                </span>
            </div>
            <div class="ncp-social-container d-flex mb-1" 
                [ngClass]="{'justify-content-center': cardType === cardTypeConst.MULTI, 'justify-content-between': cardType !== cardTypeConst.MULTI}">
                <ng-container *ngIf="cardType !== cardTypeConst.SINGLE; else playedCount">
                    <ng-container *ngTemplateOutlet="playedCount"></ng-container>
                </ng-container>
            </div>
            <ng-container *ngIf="cardType !== cardTypeConst.SINGLE; else socialContent">
            </ng-container>
        </div>
    </ng-container>
    
    
    <ng-template #playedCount>
        <ng-container *ngIf="cardType === cardTypeConst.MULTI; else likeContent">
        </ng-container>
        <div class="d-flex align-items-center secondary-paragraph"
            [ngClass]="{'max-w-40': cardType === cardTypeConst.SINGLE}"
            [ngStyle]="{'color': templateColor.sponser_category}">
            <!--TODO: to use when using actual user profiles-->
            <!-- <div class="profile-group"></div>
            <div class="profile-group"></div>
            <div class="profile-group"></div> -->
            <img [src]="image.play_image" class="ncp-player-img" alt="play image"/>
            <span class="ml-2 ellipsis">
                {{count.play_count}}{{templateText.play_count}}
            </span>
        </div>
    </ng-template>
    
    <ng-template #socialContent>
        <hr class="separator"/>
        <div class="ncp-social-content d-flex justify-content-between mt-2">
            <div class="ncp-like d-flex cursor-pointer"
                (click)="likeProduct()"
                [appAnalyticsEvent]="analyticsLikeData">
                <ng-container *ngIf="!loader">
                    <ng-container *ngTemplateOutlet="likeIcon"></ng-container>
                </ng-container>
                <ng-container *ngTemplateOutlet="loadingContent"></ng-container>
                <span class="ml-2 button" [ngStyle]="{'color': likeColor}">
                {{product.is_liked ? mls.languageText.ncp_card_screen.key7 : mls.languageText.ncp_card_screen.key1}}</span>
            </div>
            <div class="ncp-comment d-flex cursor-pointer"
                (click)="navigateToProductDetail()"
                [appAnalyticsEvent]="analyticsCommentData">
                <ng-container *ngTemplateOutlet="commentIcon"></ng-container>
                <span class="ml-2 button" [ngStyle]="{'color': templateColor.like_comment_share}">{{mls.languageText.ncp_card_screen.key4}}</span>
            </div>
            <div class="ncp-share d-flex cursor-pointer"
                (click)="shareProduct()"
                [appAnalyticsEvent]="analyticsShareData">
                <ng-container *ngTemplateOutlet="shareIcon"></ng-container>
                <span class="ml-2 button" [ngStyle]="{'color': templateColor.like_comment_share}">{{mls.languageText.ncp_card_screen.key5}}</span>
            </div>
        </div>
    </ng-template>
    
    <ng-template #likeContent>
        <div class="d-flex align-items-center secondary-paragraph"
          [ngStyle]="{'color': templateColor.sponser_category}">
            <span class="ncp-likes cursor-pointer "
                (click)="getProductLikeList()">
                {{count.like}} {{mls.languageText.ncp_card_screen.key2}}
            </span>
            <span class="d-inline-flex ellipse-separator" 
                [ngStyle]="{'background-color': templateColor.sponser_category}">
            </span>
            <span class="ncp-comments">{{count.comment}} {{mls.languageText.ncp_card_screen.key4}}</span>
        </div>
    </ng-template>
    
    <!-- like list popup start**************************** -->
    <app-product-like *ngIf="showLikeListModal"
        (resetLikeModalList)="resetLikeModalList($event)"
        (resetLike)="resetLike($event)"
        [likeObj]="likeObject">
    </app-product-like>
    <!-- like list popup end ***************************** -->
    
    <!--Loader-->
    <ng-template #loadingContent>
        <ng-container *ngIf="loader">
            <img src="assets/themes/icons/primary-loader.gif"
                class="cursor-pointer"
                height="20"
                width="20"
                alt="loader"/>
        </ng-container>
    </ng-template>
    <!--Loader-->
    
    <ng-template #likeIcon>
        <svg width="19" height="20" viewBox="0 0 19 20" fill="none">
            <defs>
                <style>
                    .ncp-liked-icon-{{product.product_type_id}} {
                        fill: {{likeColor}};
                    }
                </style>
            </defs>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.53813 9.33586L0.538099 9.33583C0.261952 9.33582 0.0380859 9.55969 0.0380859 9.83583V10.8359V17.6707V18.6707C0.0380859 18.9469 0.261944 19.1707 0.538086 19.1707H1.53809H14.3278C14.8547 19.1707 15.4047 19.04 15.8784 18.7039C16.363 18.3599 16.6736 17.8656 16.7987 17.3234C16.9022 16.875 16.8769 16.4321 16.7633 16.0151C17.0285 15.7225 17.244 15.369 17.3711 14.9501C17.5468 14.3709 17.5148 13.8044 17.3347 13.2788C17.6461 12.9156 17.8806 12.4785 17.9821 11.9582C18.0904 11.4029 18.0228 10.8755 17.8493 10.3925C18.1267 10.0068 18.3086 9.56502 18.3816 9.11728C18.5582 8.03417 18.0988 6.79102 16.804 6.22839L16.518 6.10411L16.2062 6.10411L9.71321 6.10417L9.84087 3.41261C9.90741 2.00974 8.78796 0.835938 7.38351 0.835938C6.26239 0.835938 5.28306 1.59393 5.00197 2.67925L3.27793 9.33591L1.53813 9.33586ZM14.9578 15.4858C14.8927 15.5136 14.8712 15.5975 14.9153 15.6529C15.2787 16.1086 15.4139 16.5752 15.3457 16.9447C15.2668 17.3728 14.9147 17.6707 14.3278 17.6707H4.49702V10.6116L6.45406 3.05533C6.56376 2.63176 6.94597 2.33594 7.38351 2.33594C7.93163 2.33594 8.36852 2.79404 8.34256 3.34155L8.21152 6.10419L8.16522 7.0805C8.1517 7.36562 8.37922 7.60419 8.66466 7.60418L9.64207 7.60417L16.2062 7.60411C16.9918 7.94547 17.074 8.77439 16.7143 9.39001C16.5655 9.64459 16.3411 9.86269 16.0597 9.99476C15.9964 10.0244 15.9739 10.1067 16.0167 10.1619C16.3611 10.6055 16.5333 11.0312 16.5335 11.4234C16.5336 11.5852 16.5044 11.7414 16.4459 11.8907C16.3016 12.2594 15.9791 12.5866 15.4786 12.8559C15.4182 12.8884 15.4046 12.9704 15.451 13.0209C15.8348 13.4386 15.9934 13.8427 15.9851 14.205C15.9823 14.3311 15.9592 14.4522 15.9184 14.5671C15.777 14.965 15.4224 15.2878 14.9578 15.4858ZM2.99702 10.8359V17.6707H1.53809V16.1707V12.3359V10.8359L2.99702 10.8359Z" class="ncp-liked-icon-{{product.product_type_id}}"/>
        </svg>
    </ng-template>
    <ng-template #commentIcon>
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
            <defs>
                <style>
                  .ncp-comment-icon-{{product.product_type_id}} {
                    fill: {{templateColor.like_comment_share}};
                  }
                </style>
              </defs>
            <path class="ncp-comment-icon-{{product.product_type_id}}" fill-rule="evenodd" clip-rule="evenodd" d="M15.228 17H5.22803C4.12346 17 3.22803 16.1046 3.22803 15V5C3.22803 3.89543 4.12346 3 5.22803 3H19.228C20.3326 3 21.228 3.89543 21.228 5V21L15.228 17ZM19.728 18.1972L15.6822 15.5H5.22803C4.95189 15.5 4.72803 15.2761 4.72803 15V5C4.72803 4.72386 4.95189 4.5 5.22803 4.5H19.228C19.5042 4.5 19.728 4.72386 19.728 5V18.1972Z" class="ncp-comment-icon-{{product.product_type_id}}"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.228 9H7.22803V7.5H16.228V9Z" class="ncp-comment-icon-{{product.product_type_id}}"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.228 13H10.228V11.5H16.228V13Z" class="ncp-comment-icon-{{product.product_type_id}}"/>
            </svg>
        <!-- <svg width="20" height="20" viewBox="0 0 20 20">
            <g clip-path="url(#anx37tqg4a)">
                <path class="ncp-comment-icon-{{product.product_type_id}}" d="M12.7 2H6.3C3.4 2 1 4.3 1 7.2V10c0 2.7 2 4.9 4.6 5.3v2.1c0 .3.2.6.5.7.1 0 .2.1.3.1.2 0 .4-.1.5-.2l2.5-2.5h3.3c2.9 0 5.3-2.3 5.3-5.2v-3C18 4.4 15.7 2 12.7 2c.1 0 0 0 0 0zM5.4 5.7h6.4c.4 0 .8.3.8.8 0 .4-.3.7-.6.8H5.4c-.4 0-.8-.4-.8-.8.1-.4.4-.8.8-.8zm8.2 5.1H5.4c-.4 0-.7-.3-.7-.7V10c0-.4.3-.7.6-.8H13.6c.4 0 .8.3.8.8.1.5-.3.8-.8.8z"/>
            </g>
            <defs>
              <style>
                .ncp-comment-icon-{{product.product_type_id}} {
                  fill: {{templateColor.like_comment_share}};
                }
              </style>
                <clipPath id="anx37tqg4a">
                    <path transform="translate(1 2)" d="M0 0h17v16.1H0z"/>
                </clipPath>
            </defs>
        </svg> -->
    </ng-template>
    <ng-template #shareIcon>
        <svg width="25" height="20" viewBox="0 0 25 20" fill="none">
            <defs>
                <style>
                  .ncp-share-icon-{{product.product_type_id}} {
                    fill: {{templateColor.like_comment_share}};
                  }
                </style>
            </defs>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.776 0.984242C14.1355 0.36007 13.0595 0.813911 13.0595 1.70827V5.28258C10.6614 5.30198 6.6837 5.80039 3.78621 8.62493C1.01424 11.3251 0.663706 14.8326 0.637354 17.9667C0.632763 18.5128 1.02684 18.8385 1.34722 18.9426C1.66446 19.0457 2.14959 19.0145 2.4715 18.6094C3.20583 17.6853 6.23328 14.4804 13.0595 14.7229V18.2897C13.0595 19.1408 14.0471 19.611 14.7078 19.0744L19.7544 14.9759L23.9889 11.5371C24.4584 11.1559 24.4903 10.4505 24.0571 10.0284L14.776 0.984242ZM14.8435 3.541L22.19 10.6999L18.6298 13.591L14.8435 16.666V13.989C14.8435 13.4408 14.4132 13.0158 13.9003 12.9806C7.98534 12.5746 4.39627 14.5017 2.49722 16.0709C2.68375 13.7398 3.28025 11.6082 5.03125 9.90264C7.72932 7.27249 11.6842 7.00154 13.7975 7.07636C14.3809 7.09701 14.8435 6.62713 14.8435 6.06559V3.541Z" class="ncp-share-icon-{{product.product_type_id}}"/>
            </svg>
            
        <!-- <svg width="20" height="20" viewBox="0 0 20 20">
            <defs>
              <style>
                .ncp-share-icon-{{product.product_type_id}} {
                  fill: {{templateColor.like_comment_share}};
                }
              </style>
            </defs>
            <path class="ncp-share-icon-{{product.product_type_id}}" d="M11.583 15.133V11.58C7.133 11.58 4.225 12.967 2 16c.856-4.333 3.422-8.667 9.583-9.533V3L18 9.067l-6.417 6.066z"/>
        </svg> -->
    </ng-template>